// extracted by mini-css-extract-plugin
export default {"item":"Card_item__MSuQ8","img":"Card_img__AKxwK"};